const env = process.env.NODE_ENV || "development";

const config = require("./config-data");

const envConfig = config[env];

export default envConfig;
